import React, { useRef, useState, useEffect } from 'react';
import { Menubar } from 'primereact/menubar';
import { InputText } from 'primereact/inputtext';
import { Avatar } from 'primereact/avatar';
import { items } from './utils';
import styles from './styles';
import { Button } from 'primereact/button';
import {
  CURRENCY,
  usePaymentCurrency,
} from 'Providers/PaymentCurrencyProvider';

import dioArtLogo from '../../assets/dio_art_logo.svg';
import { useCollections } from 'Providers/CollectionsProviders';
import { Link, useNavigate } from 'react-router-dom';
import './styles.css';

const Template = ({ categories, eventData, subCategories }) => {
  const navigate = useNavigate();
  const { newSearch } = useCollections();
  const [search, setSearch] = useState('');
  const menuBarRef = useRef(null);
  const { currency, setCurrency } = usePaymentCurrency();
  const [currencyFade, setCurrencyFade] = useState(false);

  useEffect(() => {
    setCurrencyFade(true);
    const timeout = setTimeout(() => setCurrencyFade(false), 400);
    return () => clearTimeout(timeout);
  }, [currency]);

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      if (location.pathname !== 'search')
        navigate(`/search?search=${event.target.value}`);
    }
  };
  const goToSearch = () => {
    if (location.pathname !== 'search') {
      navigate(`/search?search=${search}`);
      setSearch('');
    }
  };

  const start = (
    <Link to="/" style={{ paddingRight: 8 }}>
      <img alt="logo" src={dioArtLogo} height="40" className="mr-2"></img>
    </Link>
  );

  const currencyOptions = [
    {
      code: CURRENCY.ARS,
      label: CURRENCY.ARS,
      flag: '🇦🇷',
    },
    {
      code: CURRENCY.USD,
      label: CURRENCY.USD,
      flag: '🇺🇸',
    },
  ];

  const currencySwitch = (
    <div className="currency-switch">
      <div
        style={{
          display: 'flex',
          background: 'var(--gray-700)',
          borderRadius: 20,
          padding: '2px 4px',
          position: 'relative',
          minWidth: 90,
        }}
      >
        {currencyOptions.map((option, idx) => {
          const isActive = currency === option.code;
          return (
            <button
              key={option.code}
              onClick={() => setCurrency(option.code)}
              aria-pressed={isActive}
              className={
                isActive
                  ? `currency-switch-anim currency-switch-fade${currencyFade ? '-active' : ''}`
                  : ''
              }
              style={{
                backgroundColor: isActive ? 'var(--gray-400)' : 'transparent',
                color: isActive ? 'var(--gray-900)' : 'var(--gray-200)',
                border: 'none',
                borderRadius: 16,
                margin: 0,
                padding: isActive
                  ? eventData.width < 481
                    ? styles.switchIsActiveMobile.padding
                    : eventData.width < 769
                      ? styles.switchIsActiveMedium.padding
                      : styles.switchIsActive.padding
                  : eventData.width < 481
                    ? styles.switchIsInactiveMobile.padding
                    : eventData.width < 769
                      ? styles.switchIsInactiveMedium.padding
                      : styles.switchIsInactive.padding,
                fontWeight: 600,
                fontSize: '1em',
                display: 'flex',
                alignItems: 'center',
                cursor: isActive ? 'default' : 'pointer',
                transition: 'background 0.2s',
                outline: isActive ? '2px solid var(--gray-500)' : 'none',
                minWidth: 40,
                position: 'relative',
                zIndex: 1,
              }}
              tabIndex={0}
              translate="no"
            >
              {isActive && (
                <span style={{ fontSize: '1.2em', marginRight: 4 }}>
                  {option.flag}
                </span>
              )}
              {option.label}
            </button>
          );
        })}
      </div>
    </div>
  );

  const end = (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
      }}
    >
      {currencySwitch}
      <div id="search" className="p-inputgroup flex-1 w-8rem sm:w-auto">
        <InputText
          placeholder="Buscar"
          type="text"
          style={{
            backgroundColor: 'var(--gray-600)',
            borderColor: 'var(--gray-400)',
            borderRightWidth: 0,
          }}
          onChange={(e) => {
            newSearch(e.target.value);
            setSearch(e.target.value);
          }}
          onKeyDown={handleKeyDown}
          className="searchInput"
          id="searchInput"
        />
        <Button
          icon="pi pi-search"
          className="p-button search"
          style={{
            backgroundColor: 'var(--gray-800)',
            borderColor: 'var(--gray-400)',
            color: 'var(--gray-400)',
          }}
          onClick={goToSearch}
        />
      </div>
      <div
        id="avatar"
        style={{
          display: 'flex',
          flex: 1,
          alignItems: 'center',
          paddingLeft: 16,
        }}
      >
        <Avatar
          image="https://dioart-low.s3.us-east-1.amazonaws.com/perfil.png"
          shape="circle"
          size="large"
        />
      </div>
    </div>
  );
  const collections = useCollections()?.collections;
  return (
    <div className="card">
      <Menubar
        model={items(
          collections,
          navigate,
          menuBarRef,
          subCategories,
          categories,
        )}
        start={start}
        end={end}
        s="gray-300"
        style={{
          ...styles.menu,
          width: eventData.width,
          border: 0,
          paddingLeft: 16,
          paddingRight: 16,
        }}
        ref={menuBarRef}
        id="menuBar"
      />
    </div>
  );
};

export default Template;
